import { render, staticRenderFns } from "./TimelineCarousel.vue?vue&type=template&id=1a048068&scoped=true"
import script from "./TimelineCarousel.vue?vue&type=script&lang=ts"
export * from "./TimelineCarousel.vue?vue&type=script&lang=ts"
import style0 from "./TimelineCarousel.vue?vue&type=style&index=0&id=1a048068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a048068",
  null
  
)

export default component.exports